// 加千分位
import de from "element-ui/src/locale/lang/de";

export let format = num => {
    let symbol = '';
    if (num < 0) {
        symbol = '-';
    }
    num = num.toString();
    //如果存在小数点，则获取数字的小数部分
    var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : '';
    cents = cents.length > 1 ? cents : '';
    // 负数去除符号
    num = num.replace(/-/g, '');
    //获取数字的整数数部分
    num = num.indexOf(".") > 0 ? num.substring(0, (num.indexOf("."))) : num;
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
    }

    //将数据（符号、整数部分、小数部分）整体组合返回
    return (symbol +num + cents);
}



// WEBPACK FOOTER //
// ./src/utils/math.js